import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { IonicModule, MenuController } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { OrganizationTokenModel } from 'src/app/api/proxy/organization/organization-models';
import { EventService } from 'src/app/services/events/event.service';

export const HOME_DEFAULT_TAB = 'pn-dashboard';

interface PnHomeTabSlotView {
  tab?: string;
  icon: string;
  ariaLabelKey?: string;
  opensMenu?: boolean;
  showGameBadge?: boolean;
  showNotificationBadge?: boolean;
}

@Component({
  selector: 'pn-home-page-tabs',
  templateUrl: './pn-home-page-tabs.component.html',
  styleUrls: ['./pn-home-page-tabs.component.scss'],
  imports: [CommonModule, IonicModule, TranslatePipe],
})
export class PnHomePageTabsComponent implements OnInit, OnDestroy {
  public pointsEnabled = false;
  public notificationCount = 0;
  public gameAvailable = false;

  private subscriptions: Subscription[] = [];

  get navigationTabSlot(): PnHomeTabSlotView {
    return {
      icon: 'assets/v3/Navigation.svg',
      ariaLabelKey: 'home-page.tab.navigation',
      opensMenu: true,
    };
  }

  get wearablesTabSlot(): PnHomeTabSlotView {
    return {
      tab: 'wearables',
      icon: 'assets/v3/device-icon.svg',
      ariaLabelKey: 'home-page.tab.wearables',
    };
  }

  get healthScoreTabSlot(): PnHomeTabSlotView {
    return {
      tab: 'pn-dashboard',
      icon: 'assets/v3/Heart.svg',
      ariaLabelKey: 'home-page.tab.health-score',
    };
  }

  get pointsTabSlot(): PnHomeTabSlotView | undefined {
    if (!this.pointsEnabled) {
      return undefined;
    }
    return {
      tab: 'points-detail',
      icon: 'assets/v3/Points.svg',
      showGameBadge: true,
    };
  }

  get notificationTabSlot(): PnHomeTabSlotView | undefined {
    return {
      tab: 'notification',
      icon: 'assets/v3/Notifications.svg',
      showNotificationBadge: true,
    };
  }

  constructor(
    private menu: MenuController,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      EventService.notificationCount.subscribe((count: number) => {
        this.notificationCount = count;
        this._changeDetectorRef.markForCheck();
      }),
      EventService.organizationConfigLoaded.subscribe((v: OrganizationTokenModel) => {
        const pointsEnabled = v && v.vivaScorePointsModuleEnabled === true;
        this.pointsEnabled = pointsEnabled;
        if (!pointsEnabled) {
          this.gameAvailable = false;
        }
        this._changeDetectorRef.markForCheck();
      }),
      EventService.gameAvailable.subscribe((available: boolean) => {
        this.gameAvailable = available && this.pointsEnabled;
        this._changeDetectorRef.markForCheck();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  async openMenu(): Promise<void> {
    await this.menu.open();
  }
}
